import { EventBus, ViewModel } from '@descomplica/microfrontend-core';
import { action, computed, makeObservable } from 'mobx';

import { SelectClassifierEvent } from '@/presentation/events/select-classifier.event';
import { ClassifiersModel } from '@/presentation/models/classifiers.model';

@ViewModel()
export class SelectClassifierMenuViewModel {
  constructor(
    private readonly eventBus: EventBus,
    private readonly classifiersModel: ClassifiersModel,
  ) {
    makeObservable(this);
  }

  @computed
  get highestClassificationLevel() {
    return this.classifiersModel.classifiers;
  }

  @computed
  get highestClassificationLevelName() {
    return this.classifiersModel.highestClassificationLevelName;
  }

  @computed
  get selectedOption() {
    return this.classifiersModel.selectedClassifier;
  }

  @action
  async selectClassifier(classifierGuid: string) {
    this.classifiersModel.selectClassifier(classifierGuid);

    const selectClassifierEvent = new SelectClassifierEvent();
    this.eventBus.emit(selectClassifierEvent);
  }
}
